// extracted by mini-css-extract-plugin
export default {"root":"IconSettings_root__UGb-x"};